/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Og_Faq_Q_Open_RoundsInputs */



/**
* | output |
* | --- |
* | "What are Open Rounds?" |
*
* @param {Og_Faq_Q_Open_RoundsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const og_faq_q_open_rounds = /** @type {((inputs?: Og_Faq_Q_Open_RoundsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Og_Faq_Q_Open_RoundsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Que sont les rondes libres ?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Qué son las rondas abiertas?")
	if (locale === "pt") return /** @type {LocalizedString} */ ("O que são rodadas abertas?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cosa sono i round liberi?")
	return /** @type {LocalizedString} */ ("What are Open Rounds?")
});